import axios from "axios";

const BACKEND_URL =
  typeof window !== "undefined" ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "payments_access_token";

export function getAccessToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    console.warn("Unable to read auth token from storage", e);
    return null;
  }
}
export function setAccessToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    console.warn("Unable to persist auth token to storage", e);
  }
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Always attach the bearer token from localStorage as a fallback for
// browsers that refuse the SameSite=None; Secure cookie.
api.interceptors.request.use((config) => {
  const t = getAccessToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// If any API request comes back 401 (except the login call itself),
// the cookie/token is stale/expired — clear state and go back to login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthCall = url.includes("/auth/login");
    if (status === 401 && !isAuthCall) {
      setAccessToken(null);
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);

export const newKey = () =>
  (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export async function downloadJson(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  return String(d);
}
